import MuiTableGrid from './MuiTableGrid';

export default MuiTableGrid;
